<template>
    <div v-if="ajaxSearch">
        <el-autocomplete
                size="medium"
                style="width: 100%"
                v-model="keyword"
                :fetch-suggestions="querySearch"
                :placeholder="placeholder"
                :trigger-on-focus="true"
                @keyup.native.13="enterKeyFn"
                @select="handleSelect"
        >
        <i slot="suffix" @click="iconClickHandler" :class="keyword ? 'circle-close' : ''"></i>
        </el-autocomplete>
    </div>
    <div v-else>
        <el-input
                size="medium"
                style="width: 100%"
                v-model="keyword"
                :placeholder="placeholder"
                @keyup.native.13="enterKeyFn"
        >
        <i slot="suffix" @click="iconClickHandler" :class="keyword ? 'circle-close' : ''"></i>
        </el-input>
    </div>

</template>
<script type="text/javascript">
    import axios from 'axios'

    export default {
        name: 'searchBar',
        props: {
            placeholder: {
                type: String,
                'default': '请输入内容'
            },
            value: {
                type: String,
                'default': ''
            },
            ajaxSearch: {
                type: Boolean,
                'default': true
            },
            enterKey: Function,
            config: {
                type: Object,
                'default': function () {
                    return {
                        url: '/resume/list.api',
                        keyName: 'name'
                    }
                }
            }
        },
        data () {
            return {
                url: '/hunter/searchWord.api',
                keyword: this.value,
                isPass: true,
                timeout: null
            }
        },
        watch: {
            keyword (value) {
                this.$emit('input', value)
            }
        },
        methods: {
            querySearch (keyword, callback) {
                if (this.isPass) {
                    this.isPass = false
                    this.timeout = setTimeout(() => {
                        this.getRequestFn(callback)
                    }, this.timeout ? 500 : 0)
                }
            },
            getRequestFn (callback) {
                let data = {},
                    CancelToken = axios.CancelToken
                if (this.getRequest) {
                    this.source.cancel('取消未返回的请求')
                }
                this.source = CancelToken.source()
                data[this.config.keyName] = this.keyword
                this.getRequest = axios.get(this.config.url, {
                    params: data,
                    cancelToken: this.source.token,
                    'X-loadingOff': true
                }).then(res => {
                    let list = []

                    this.isPass = true
                    res.result.list.forEach((item, index) => {
                        list.push({value: typeof item === 'string' ? item : item[this.config.keyName]})
                    })
                    callback(list)
                }).catch(() => {
                    let list = []
                    this.isPass = true
                    callback(list)
                })
            },
            handleSelect (item) {
                this.$emit('select', item.value)
            },
            iconClickHandler () {
                this.keyword = ''
            },

            enterKeyFn () {
                this.$emit('enter-key', this.keyword)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// searchBar.vue?60bda30e